// extracted by mini-css-extract-plugin
export default {"categorySection":"ProductList_categorySection__44QRt","productList":"ProductList_productList__98Tcc"};